<template>
	<v-dialog
		v-model="showDialog"
		v-bind="$attrs"
		persistent
		:fullscreen="$vuetify.breakpoint.smAndDown"
		max-width="1153px"
	>
		<slot />
	</v-dialog>
</template>

<script>
	export default {
		data() {
			return {
				showDialog: false
			};
		},

		methods: {
			open() {
				this.showDialog = true;
			},

			close() {
				this.showDialog = false;
			}
		}
	};
</script>